import React from "react";
import { SpecsInputField } from "../SpecsEditorFields/index";

type SpecsNumberFieldProps = {
  label: string;
  value: number | null;
  allowNull?: boolean;
  placeholder?: string;
  helperText?: string;
  debugPath?: string;
  clickToEdit?: boolean;
  onChange: (nextValue: number | null) => void;
};

export default function SpecsNumberField({
  label,
  value,
  allowNull,
  placeholder,
  helperText,
  debugPath,
  clickToEdit,
  onChange,
}: SpecsNumberFieldProps) {
  const [inputValue, setInputValue] = React.useState(
    value === null ? "" : String(value)
  );

  React.useEffect(() => {
    setInputValue(value === null ? "" : String(value));
  }, [value]);

  const commit = React.useCallback(
    (nextInputValue: string) => {
      if (!nextInputValue.trim()) {
        const nextValue = allowNull ? null : 0;
        setInputValue(nextValue === null ? "" : String(nextValue));
        onChange(nextValue);
        return;
      }

      const nextValue = Number(nextInputValue);
      if (!Number.isFinite(nextValue)) {
        return;
      }

      setInputValue(String(nextValue));
      onChange(nextValue);
    },
    [allowNull, onChange]
  );

  return (
    <SpecsInputField
      label={label}
      type="number"
      value={inputValue}
      placeholder={placeholder}
      helperText={helperText}
      debugPath={debugPath}
      clickToEdit={clickToEdit}
      onChange={(event) => {
        const nextValue = event.target.value;
        setInputValue(nextValue);

        if (["", "-", ".", "-."].includes(nextValue)) {
          return;
        }

        const parsed = Number(nextValue);
        if (Number.isFinite(parsed)) {
          onChange(parsed);
        }
      }}
      onBlur={() => {
        commit(inputValue);
      }}
    />
  );
}
